// removed by extract-text-webpack-plugin
module.exports = {"hidden":"Qi9_q","visuallyhidden":"_1AXzs","hide-text":"_2ZD7_","center":"_3Y608","noprint":"_1ybf9","carousel":"_1mCJ0","slideContainer":"ARJ08","slideContainerViewport":"_1-65-","slide":"_29Iwb","slideItemWrapper":"_17sRR","changeSlideButton":"_2APk9","changeSlideButtonDisabled":"_5PreY"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-carousel/styles/default.scss
 ** module id = 992
 ** module chunks = 2
 **/